import * as React from 'react';
import clsx from 'clsx';

// Keep paths unfilled when NavbarList applies `fill-current` to the SVG.
function HealthcareBuildingIcon({className, ...props}) {
  return (
    <svg
      className={clsx('lucide lucide-hospital w-6 h-6', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 6v4" fill="none" />
      <path d="M14 14h-4" fill="none" />
      <path d="M14 18h-4" fill="none" />
      <path d="M14 8h-4" fill="none" />
      <path
        d="M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2"
        fill="none"
      />
      <path
        d="M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18"
        fill="none"
      />
    </svg>
  );
}

export default HealthcareBuildingIcon;
